import { QuoteFormChangeEditionRequestBody, QuoteFormItemRequestParams, QuoteFormSearchResponse } from '@lio/api-types';
import { formVersionQueryKeys } from '@services/formVersion/keys';
import { quoteFormQueryKeys } from '@services/quoteForm/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useChangeQuoteFormEdition = () => {
  const client = useClient();
  const queryClient = useQueryClient();

  const result = useMutation({
    mutationFn: async ({
      quoteId,
      quoteFormId,
      newFormVersionId,
    }: QuoteFormChangeEditionRequestBody & QuoteFormItemRequestParams) => {
      return client
        .post(`quote/${quoteId}/quote-form/${quoteFormId}/change-edition`, {
          json: { newFormVersionId },
        })
        .json<QuoteFormSearchResponse['items'][number]>();
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['quote', { quoteId: variables.quoteId }],
      });
      queryClient.invalidateQueries({
        queryKey: quoteFormQueryKeys.searchWithParams({ quoteId: variables.quoteId }),
      });
      queryClient.invalidateQueries({
        queryKey: formVersionQueryKeys.get(variables.quoteId),
      });
    },
  });

  return {
    ...result,
    changeQuoteFormEdition: result.mutate,
    changeQuoteFormEditionAsync: result.mutateAsync,
  };
};
